import $ from 'jquery';
import _ from 'underscore';
import Backbone from "backbone";
import ParagraphLayoutBehavior from "../ParagraphLayoutBehavior";
import ReplacementSequencerNode from "models/audioEditor/sequencerNodes/ReplacementSequencerNode";
import DeletionSourceFactory from 'models/audioEditor/DeletionSourceFactory';
import RSVP from "rsvp";

const CLASSNAME = "DeletedSequencerNode";
const DeletedSequencerNode =  ReplacementSequencerNode.extend({
    idAttribute: "id",


    constructor: function(attributes, options) {
        ReplacementSequencerNode.apply(this, [attributes, options]);

        
    },

    getParagraphLayoutBehavior : function(){
        return ParagraphLayoutBehavior.presets.associateWithNextParagraph(
            ReplacementSequencerNode.prototype.getParagraphLayoutBehavior ? ReplacementSequencerNode.prototype.getParagraphLayoutBehavior.call(this) : null,
        );
    },

    getConstructor : function(){
        return DeletedSequencerNode;
    },

    setDeletionSource: function(deletionSource){
        this.set("deletionSource",deletionSource);
    },

    getDeletionSource: function(){
        return this.get("deletionSource")
    },

    cloneJSON: function(){
        const objJson = ReplacementSequencerNode.prototype.cloneJSON.call(this);
        objJson.type = DeletedSequencerNode.CLASSNAME;
        objJson.deletionSource = this.getDeletionSource()?.clone();
        return objJson;
    },

    getSerializedData : function(){
        const serializedData = ReplacementSequencerNode.prototype.getSerializedData.call(this);
        serializedData.deletionSource = this.getDeletionSource()?.getSerializedData();
        return serializedData;
    },

    restoreFromSerializedData: function(serializedData, audioSegmentFactoryInstance, audioFilterFactoryInstance, additionalSpeakerInfoArray){
        ReplacementSequencerNode.prototype.restoreFromSerializedData.call(this, serializedData, audioSegmentFactoryInstance, audioFilterFactoryInstance, additionalSpeakerInfoArray);
        this.setDeletionSource(DeletionSourceFactory.getInstance().createDeletionSourceForSerializedData(serializedData.deletionSource));
    },

    afterAllInstancesCreatedFromSerializedData : function(serializedData, sequencerNodeCidToSequencerNodeMap){
        ReplacementSequencerNode.prototype.afterAllInstancesCreatedFromSerializedData.call(this, serializedData, sequencerNodeCidToSequencerNodeMap);
    },




});

DeletedSequencerNode.CLASSNAME =  CLASSNAME;
export default DeletedSequencerNode;
